export enum EEntryAction {
  PagesAdded = 'PAGES ADDED',
  PageRemoved = 'PAGE REMOVED',
  PageUpdated = 'PAGE UPDATED',
  PagesRearranged = 'PAGES REARRANGED',
}
